import { makeActionCreator } from '../../config/store/utils'
import { getProviderSalesDistribution } from '../../services/providers'

const BUBBLE_DATA_BASE = [
  { x: 0 },
  { x: 1 },
  { x: 2 },
  { x: 3 },
  { x: 4 },
  { x: 5 },
  { x: 6 },
  { x: 7 },
  { x: 8 },
  { x: 9 },
  { x: 10 },
  { x: 11 }
]

export const GET_PROVIDER_SALES_DISTRIBUTION = 'GET_PROVIDER_SALES_DISTRIBUTION'
export const GET_PROVIDER_SALES_DISTRIBUTION_ERROR = 'GET_PROVIDER_SALES_DISTRIBUTION_ERROR'
export const GET_PROVIDER_SALES_DISTRIBUTION_SUCCESS = 'GET_PROVIDER_SALES_DISTRIBUTION_SUCCESS'
export const onGetProviderSalesDistribution = makeActionCreator(GET_PROVIDER_SALES_DISTRIBUTION)
export const onGetProviderSalesDistributionError = makeActionCreator(GET_PROVIDER_SALES_DISTRIBUTION_ERROR, 'payload')
export const onGetProviderSalesDistributionSuccess = makeActionCreator(
  GET_PROVIDER_SALES_DISTRIBUTION_SUCCESS,
  'payload'
)
export const onGetProviderSalesDistributionThunk = payload => async dispatch => {
  dispatch(onGetProviderSalesDistribution())

  try {
    const { data = {} } = await getProviderSalesDistribution({
      actionType: GET_PROVIDER_SALES_DISTRIBUTION,
      dni: payload.dni,
      mechanismId: payload.mechanismId,
      sectorId: payload.sectorId,
      year: payload.year
    })
    const bubbleData =
      data.payload?.map(item => ({
        amount: item.amountCLP,
        amountUSD: item.amountUSD,
        id: item.idSector,
        name: item.sector,
        month: item.numberMonth,
        orders: item.numberMonthOC,
        percentage: item.percentage,
        provider: item.supplier,
        totalAmount: item.amountCLPSectorAnnual,
        totalAmountUSD: item.amountUSDSectorAnnual,
        totalOrders: item.numberMonthOCSectorAnnual,
        x: item.numberMonth - 1,
        y: item.amountCLP,
        year: item.year,
        z: item.numberMonthOC
      })) || []
    const enhancedData = BUBBLE_DATA_BASE.concat(bubbleData)
    const csv = [
      ['Año', 'Mes', 'Proveedor', 'Sector', 'Nº de órdenes de compra', 'Monto transado', 'Monto transado (USD)'],
      ...bubbleData.map(item => [
        item.year,
        item.month,
        item.provider,
        item.name,
        item.orders,
        item.amount,
        item.amountUSD
      ])
    ]
    const [item] = bubbleData

    return dispatch(
      onGetProviderSalesDistributionSuccess({
        csv,
        data: enhancedData,
        lengthData: bubbleData.length || 0,
        totalAmount: item?.totalAmount || 0,
        totalAmountUSD: item?.totalAmountUSD || 0,
        totalOrders: item?.totalOrders || 0
      })
    )
  } catch (error) {
    return dispatch(onGetProviderSalesDistributionError({ error }))
  }
}
